import {cDisplay} from '../creator/cDisplay'
import { cGame } from '../creator/cGame';
import { cButton } from '../creator/cGameObjects/cButton';
import { addCoinAnimation } from '../creator/cDisplayObjects/EvaluationCard';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';
import { net } from '../creator/utils/net';

import * as md5 from 'md5';
import { cText } from '../creator/cGameObjects/cText';

export class votingDisplay extends cDisplay {

  private curData: any;

  init(){
    super.init();

    //tasks
    (this.scene as cScene).ev.addListener('action',(command,options)=>{
      switch (options.command ){
        case 'get':
          this.getVoting( this.getUrl() ).then( data=>this.buildVoting(data) );
          break;
        case 'submit':
          var vote = (this.scene as cScene).getState('vote');
          var id = this.getID()
          var time = (new Date()).getTime();
          var st = `${id}-${vote}-${time}-X3TQBWx2G32Z9[7`;

          this.postVoting( this.getUrl(),{
            ID:id,
            value:vote,
            date:time,
            hash: md5(st)
          }).then(data=>{
            this.buildResult(data);
          });

          console.log(st, md5('kdjsfkljsdfkl') );
      }
    })    
    
  }

  getID(){
    var id = (this.scene as cScene).getState('current_voting')
    if (id == 0){ id = 'klima_1'; }
    return id;
  }

  getUrl(){
    let url = document.querySelector('body').getAttribute('server');
    if (url === '{{$server_url}}') url = 'http://localhost:8200';
    url += '/voting/'+this.getID()
    return url;
  }


  async getVoting(url){
    const response = await fetch(url, {});
    return await response.json();
  }

  async postVoting(url,data){
    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data) // body data type must match "Content-Type" header      
    });
    return await response.json();
  }

  buildVoting(data){    
    this.curData = data;
    var txt = this.getByName('txt_title').text = data.frage;
    for (var a = 1; a < 6; a++){
      if (data['antwort_'+a]){
        var r = this.getByName('vote_'+a);
        r.text = data['antwort_'+a];
        r.angle = (Math.random()*6)-3;
        r.visible = true; 
      }
    }
  }

  buildResult(data){
    var answers = Object.keys( data ).map( (k)=>{ console.log(k.indexOf('antwort'),data[k]);return k.indexOf('antwort')===0 ? data[k] : null } ).filter( (v)=>v!==null);
    var tg = (this.scene as cScene).getByName('answer_holder');
    answers.forEach( (res,i)=>{
      var block = new AnswerBlock(this.scene,(i+1),res / data.count, this.curData['antwort_'+(i+1)]);
      this.scene.add.existing( block )
      tg.add(block);
    });


    (this.scene as cScene).triggerSceneEvent('result');
  }

  buildScene(){
    super.buildScene();
  }

  
}


class AnswerBlock extends Phaser.GameObjects.Container {

  private ref: cText
  private block: Phaser.GameObjects.Sprite
  private end: Phaser.GameObjects.Sprite

  public pct: number = 0

  constructor(scene,idx, vote,text){
    super(scene)

    var targetPCT = Math.round(vote*100);

    this.ref = (this.scene as cScene).getByName('vote_pct_'+(idx));
    var reftxt = (this.scene as cScene).getByName('vote_text_'+(idx));

    this.x = this.ref.x;
    this.y = this.ref.y;

    let sc:cScene = scene as cScene;    

    this.ref.text = 0+'%'
    reftxt.text = text;

    var yy = 16
    var st = new Phaser.GameObjects.Sprite(this.scene,0,yy,'vote_block','block_start.png')
    st.setOrigin(0,0);
    this.add(st)

    this.block = new Phaser.GameObjects.Sprite(this.scene,13,yy,'vote_block','block_mid.png')
    this.block.setOrigin(0,0);
    this.add(this.block)

    this.end = new Phaser.GameObjects.Sprite(this.scene,13,yy,'vote_block','block_end.png')
    this.end.setOrigin(0,0);
    this.add(this.end)


    this.scene.tweens.add({
      targets:[this],
      pct: targetPCT,
      duration:800,
      onUpdate:()=>{ 
        this.updateBlock( this.pct / 100);
      }
    })

    this.updateBlock(0.5)

  }

  updateBlock(len){
    this.block.scaleX = len;
    this.end.x = this.block.displayWidth+12;
    this.ref.x = this.x + this.end.x + 40;
    this.ref.text = Math.round(len*100)+'%'
    
  }

}
